export const getOrdersHistory = (state) => ({
    orders: state.orders.orders,
    returns: state.orders.returns,
    afterCares: state.orders.afterCares,
    loading: state.orders.loading,
});
export const getOrdersPage = (state) => ({
    orders: state.orders.orders,
    returns: state.orders.returns,
    loading: state.orders.loading,
    orderTotal: state.orders.orderTotal,
    returnTotal: state.orders.returnTotal,
});
export const getReturnableOrders = (state) => {
    var _a;
    return ({
        orders: (_a = state.orders.orders) === null || _a === void 0 ? void 0 : _a.filter((o) => o.isEligibleForReturn || o.isEligibleForReturnInDifferentCountry),
        returns: state.orders.returns,
        afterCares: state.orders.afterCares,
        loading: state.orders.loading,
    });
};
export const getReturnsInfo = (state) => ({
    returnFlow: state.orders.returnFlow,
    errorMessage: state.orders.errorMessage,
    confirmedReturn: state.orders.confirmedReturn,
    returnRequest: state.orders.returnRequest ||
        {
            items: [],
            orderNo: null,
        },
    currentOrderDetail: state.orders.currentOrderDetail,
});
export const isUserAuthenticated = (state) => state.userInfo;
